import { Directive, ElementRef, Input } from "@angular/core";
import { AuthenticationService } from "../../app/auth/service";

@Directive({
  selector: "[has_capability]",
})
export class HasCapabilityDirective {
  @Input("has_capability") permission: string | undefined;

  constructor(
    private _elementRef: ElementRef,
    private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    if (!this.authService.hasCapability(this.permission)) {
      this._elementRef.nativeElement?.remove();
    }
  }
}
